import mitt from "mitt";
import Util from "@/helper/Utility.js";
/**
 * setting
 * @method setTitle
 * @method setMsg
 * @method setBtnOk
 * @method setTag
 * @method clearModal
 * action
 * @method show
 * @method hide
 * set event callback
 * @method onClickOk
 * @method onHidden
 * event
 * @event sendCallbackOk
 * @event sendCallbackHidden
 */
export function ConfirmModalController() {
    this.title = '';
    this.msg = '';
    this.btnOk = '';
    this.tag = '';
    this.selectTier = {};
    this.blobConfig = '';
    this.walletAddress = '';
    this.pointRaw = 0
    this.pointConverted = 0
    this.busModal = new mitt();

    this.callbackOk = null;
    this.callbackHidden = null;

    //#region setter
    this.setTitle = function (title) {
        this.title = title;
        return this;
    };
    this.setMsg = function (msg) {
        this.msg = msg;
        return this;
    };
    this.setBtnOk = function (btnOk) {
        this.btnOk = btnOk;
        return this;
    };
    this.setTag = function (tag) {
        this.tag = tag;
        return this;
    };
    this.setSelectTier = function (selectTier) {
        this.selectTier = selectTier;
        return this;
    }
    this.setPoints = function (raw, converted) {
        this.pointRaw = raw
        this.pointConverted = converted
        return this
    }

    this.setBlobConfig = function (blobConfig) {
        this.blobConfig = blobConfig;
        return this;
    }
    this.setWalletAddress = function (val) {
        this.walletAddress = val;
        return this;
    }
    this.clearModal = function () {
        this.title = '';
        this.msg = '';
        this.btnOk = '';
        this.tag = '';
        this.selectTier = {};
        this.blobConfig = {};
        this.walletAddress = '';
        this.callbackOk = null;
        this.callbackHidden = null;
        this.pointRaw = 0
        this.pointConverted = 0
        return this;
    };
    //#endregion setter

    //#region method
    this.show = function () {
        var config = {
            title: this.title,
            msg: this.msg,
            btnOk: this.btnOk,
            tag: this.tag,
            selectTier: this.selectTier,
            blobConfig: this.blobConfig,
            walletAddress: this.walletAddress,
            appName: this.appName,
            pointRaw: this.pointRaw,
            pointConverted: this.pointConverted
        };
        this.busModal.$emit('show', config);
    };
    this.hide = function () {
        this.busModal.$emit('hide');
    };
    //#endregion method

    //#region event
    this.onClickOk = function (callback) {
        if (Util.isFunction(callback)) {
            this.callbackOk = callback;
        }
    },
        this.sendCallbackOk = function (data) {
            if (Util.isFunction(this.callbackOk)) {
                this.callbackOk(data);
            }
        };

    this.onHidden = function (callback) {
        if (Util.isFunction(callback)) {
            this.callbackHidden = callback;
        }
    };
    this.sendCallbackHidden = function (data) {
        if (Util.isFunction(this.callbackHidden)) {
            this.callbackHidden(data);
        }
    };
    //#endregion event
}
